export default "__VITE_PUBLIC_ASSET__3959dcfe__"